﻿export const ShoppingCartType = Object.freeze({
    ShoppingCart: 1,
    Wishlist: 2
});